export const LOGIN_STATUS = Object.freeze({
    ANONYMOUS: 'ANONYMOUS',
    LOGGED_IN: 'LOGGED_IN',
    LOGGED_OUT: 'LOGGED_OUT'
});



// WEBPACK FOOTER //
// ./web/js/stores/LOGIN_STATUS.js